import { methods } from "../../utils/axios";

export default class ChargesAPI {
  static createCharge(data) {
    return methods.post('/position', data);
  }

  static editCharge(data){
    return methods.put('/position', data)
  }

  static deleteCharge(id){
    return methods.del('/position',id)
  }

  static paginateCharge(params){
    return methods.post('/position/paginate', params)
  }

  static listCharges(data){
    return methods.post('/position_list', data)
  }

}